export enum EventEmitterMessages {
  ZoneOccupancyUpdate = 'zoneOccupancyUpdate',
}
